import { render, staticRenderFns } from "./Imprest.vue?vue&type=template&id=451d539b&scoped=true"
import script from "./Imprest.vue?vue&type=script&lang=js"
export * from "./Imprest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451d539b",
  null
  
)

export default component.exports